// Hilfsfunktionen für die einheitliche Skalierung des Organisationslogos in UI und PDF-Exporten.
export type OrganizationLogoScaleSource = {
  logo_scale_width?: number | null;
  logo_scale_height?: number | null;
};

const MIN_LOGO_SCALE = 0.5;
const MAX_LOGO_SCALE = 2;

// Normalisiert einen Skalenwert auf den erlaubten Bereich und einen sicheren Fallback.
export const normalizeLogoScale = (value: number | null | undefined, fallback = 1): number => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return fallback;
  }
  return Math.min(MAX_LOGO_SCALE, Math.max(MIN_LOGO_SCALE, value));
};

// Liefert die gespeicherten Breiten-/Höhen-Skalierungen einer Organisation.
export const getOrganizationLogoScale = (organization?: OrganizationLogoScaleSource | null) => {
  const widthScale = normalizeLogoScale(organization?.logo_scale_width, 1);
  const heightScale = normalizeLogoScale(organization?.logo_scale_height, 1);

  return { widthScale, heightScale };
};

// Skaliert konkrete Bilddimensionen auf Basis der Organisations-Einstellungen.
export const scaleLogoDimensions = (
  width: number,
  height: number,
  organization?: OrganizationLogoScaleSource | null,
) => {
  const { widthScale, heightScale } = getOrganizationLogoScale(organization);

  return {
    width: width * widthScale,
    height: height * heightScale,
  };
};
